export default __webpack_public_path__ + "static/media/BrainBreak cards65.51a3ce4a.png";